module.exports = __webpack_public_path__ + "img/welcome.d36b6f15.png";